<form [formGroup]="formGroup">
  <div class="bl-margin-bottom--16">
    <label class="bl-label bl-font-weight--800 bl-font-size--14" [class.bl-required]="field.required" for="{{ idTypeFieldId }}">
      {{ field.label }}
    </label>
    <div class="bl-select-wrap">
      <select
        class="bl-select bl-input"
        [ngClass]="{
          'bl-validation-error': (isSubmitClicked || !formGroup.controls['IdType'].pristine) && !formGroup.controls['IdType'].valid
        }"
        [id]="idTypeFieldId"
        name="IdType"
        formControlName="IdType"
        (change)="onChangeIdType()"
        [attr.data-automation-id]="field.automationId"
      >
        <option [value]="null" disabled>{{ 'dynamicPersonalInfo/select' | dictionary }}</option>
        <option [value]="item.value" *ngFor="let item of idTypes">{{ item.value }}</option>
      </select>
    </div>
    <span
      class="bl-error-msg bl-margin-right--16"
      aria-live="assertive"
      aria-label="error"
      *ngIf="(isSubmitClicked || !formGroup.controls['IdType'].pristine) && !formGroup.controls['IdType'].valid"
    >
      {{ 'dynamicPersonalInfo/required' | dictionary }}
    </span>
  </div>
</form>
